import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MomentModule } from 'ngx-moment';


import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { ContentHeaderComponent } from './content-header/content-header.component';
import { LanguageMenuComponent } from './language-menu/language-menu.component';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { LocalizeDatePipe } from './pipes/localize-date.pipe';
import { SearchBoxComponent } from '../pages/customers/search-box/search-box.component';
import { SearchCustomerComponent } from '../pages/customers/search-customer/search-customer.component';
import { SearchResultComponent } from '../pages/customers/search-result/search-result.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumbersOnlyDirective } from '../core/directives/numbers-only.directive';
import { DynamicFormComponent } from '../dynamic-forms/components/dynamic-form/dynamic-form.component';
//import { DynamicFormQuestionComponent } from '../dynamic-forms/components/dynamic-form-question/dynamic-form-question.component';
import { MyRegExDirective } from '../core/directives/my-reg-ex.directive';
import { PhoneNumberDirective } from '../core/directives/phone-number.directive';
import { TextEditorComponent } from './text-editor/text-editor.component';
// 0.18.4 and above-for Angular v7.x.x,  1.0.0 and above - for Angular v8.x.x
import { AngularEditorModule } from '@kolkov/angular-editor';
import { FormFilterPipe } from './pipes/form-filter-pipe.pipe';








@NgModule({
  declarations: [
    ContentHeaderComponent,
    LanguageMenuComponent,
    MainMenuComponent,
    LocalizeDatePipe,
    SearchBoxComponent,
    SearchCustomerComponent,
    SearchResultComponent,
    NumbersOnlyDirective,
    MyRegExDirective,
    PhoneNumberDirective,
    DynamicFormComponent,    
    TextEditorComponent, 
    FormFilterPipe   
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatMomentDateModule,
    MomentModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    TranslateModule,    
    AngularEditorModule
  ],
  exports: [
    ContentHeaderComponent,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatMomentDateModule,
    MomentModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    TranslateModule,
    MainMenuComponent,
    LanguageMenuComponent,
    LocalizeDatePipe,    
    SearchBoxComponent,
    SearchCustomerComponent,
    SearchResultComponent,
    NumbersOnlyDirective,
    MyRegExDirective,
    PhoneNumberDirective,
    DynamicFormComponent,    
    TextEditorComponent,
    FormFilterPipe
    
  ]
})
export class SharedModule { }
